import { Box, Button, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Navbar } from "react-bootstrap";
import BottomNavBar from '../components/BottomNavBar';
import { getLocalStorageMenuItem, setLocalStorageMenuItem, setMobileBackColor, setMobileCardBorderColor, setMobileTextColor } from '../utility';
import { t } from 'i18next';
import DOMPurify from 'dompurify';
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";
import { ArrowBackOutlined } from '@mui/icons-material';
const PrivacyPolicy = ({ tableQr, tableName }) => {
    const [menuTree, setMenuTree] = useState(getLocalStorageMenuItem("tree_data") || []);
    const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);
    const [loadingTree, setLoadingTree] = useState(false);
    const location = useLocation();
    const [params, setParams] = useSearchParams();
    const navigate = useNavigate();

    const loadTree = async () => {
        setLoadingTree(true);
        try {
            const timeZone = getLocalStorageMenuItem("timezone") || "";
            const promise = await axios.get(
                `${process.env.REACT_APP_API}/menus/${tableQr}/public-tree?table=${params.get('t') || null}`,
                {
                    headers: {
                        localization: getLocalStorageMenuItem("lang") || "",
                        timeZone: timeZone.replace(/["]+/g, ''),
                    },
                }
            );

            if (promise?.data?.data?.length === 0 || !promise?.data?.data?.details || !promise?.data?.data?.tree || !promise?.data?.data?.items) {
                setLoadingTreeDialog(true);
            }
            setMenuTree(promise?.data?.data || []);
            setLocalStorageMenuItem(
                "tree_data",
                JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
            );

            return promise?.data?.data;
        } catch (error) {
            // Handle error
        } finally {
            setLoadingTree(false);
        }
    };

    const loadTreeData = async () => {
        if (menuTree.length === 0 || !menuTree.details || !menuTree.tree || !menuTree.items) {
            loadTree();
        } else {
            const pathname = location.pathname;
            const pathSegments = pathname.split("/");
            const menu_code_number = pathSegments[2];
            const treeMenu_code_number = menuTree?.details?.code_number;
            if (menu_code_number !== treeMenu_code_number) {
                loadTree();
            }
        }
    };

    const handleBackHome = () => {
        navigate(
            `/${tableName}/${tableQr}/sections?section=0&t=${params.get(
                "t"
                , {
                    replace: true
                })}&lang=${getLocalStorageMenuItem("lang")}`
        );
    };

    const handleBack = () => {
        if (params.get("section")) {
            navigate(
                `/${tableName}/${tableQr}/sections?section=${params.get(
                    "section"
                )}&t=${params.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
                , {
                    replace: true
                });
        } else {
            navigate(
                `/${tableName}/${tableQr}/sections?section=0&t=${params.get(
                    "t"
                )}&lang=${getLocalStorageMenuItem("lang")}`
                , {
                    replace: true
                });
        }
    };


    const onImageError = (e) => {
        e.target.src = coverSample;
    };

    const createSanitizedHTML = (html) => {
        return {
            __html: DOMPurify.sanitize(html || '')
        };
    };

    useEffect(() => {
        loadTreeData();
    }, []);

    return (
        <div className={`min-vh-100`} style={{ backgroundColor: setMobileBackColor() }}>

            <div className="">
                <img
                    src={menuTree?.details?.cover || coverSample}
                    onError={onImageError}
                    className="slider-mobile-image"
                />
                <Navbar
                    className={`d-flex justify-content-between align-items-center mobile-top-nav`}
                    style={{ backgroundColor: setMobileBackColor() }}
                >
                    <Button
                        variant="text"
                        className={`ms-2 dark-color cursor`}
                        style={{ color: setMobileTextColor() }}
                        onClick={() => handleBack()}
                    >
                        <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                    </Button>

                    <Navbar.Brand className="text-center">
                        <img
                            src={menuTree?.details?.logo || no_image}
                            className="me-4 slider-mobile-logo cursor"
                            onError={onImageError}
                            onClick={handleBackHome}
                        />
                    </Navbar.Brand>
                </Navbar>
            </div>
            {/* Professional Header Section */}
            <Box cl sx={{
                py: 1,
                borderBottom: '1px solid',
                borderColor: setMobileCardBorderColor(),
                textAlign: 'center'
            }}>
                <Typography
                    className="head-font"
                    variant="h5"
                    component="h1"
                    sx={{
                        fontWeight: 'bold',
                        mb: 1,
                        color: setMobileTextColor()
                    }}
                >
                    {t('Privacy Policy')}
                </Typography>

            </Box>

            <Container className='alignByLang min-vh-100'>
                <Box sx={{
                    maxWidth: '800px',
                    mx: 'auto',
                    color: setMobileTextColor(),
                    marginBottom: 5,
                    backgroundColor: setMobileBackColor()
                }}>
                    {loadingTree ? (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <Typography variant="body1">
                                Loading privacy policy...
                            </Typography>
                        </Box>
                    ) : menuTree?.details?.privacy_policy ? (
                        <Box
                            className="privacy-policy-content sub-font"
                            dangerouslySetInnerHTML={createSanitizedHTML(menuTree.details.privacy_policy)}
                            sx={{
                                lineHeight: 1.8,
                                '& h2': {
                                    fontSize: '1.5rem',
                                    fontWeight: 'bold',
                                    mt: 4,
                                    mb: 2,
                                    color: setMobileTextColor()
                                },
                                '& h3': {
                                    fontSize: '1.25rem',
                                    fontWeight: 'bold',
                                    mt: 3,
                                    mb: 1.5
                                },
                                '& p': {
                                    mb: 2,
                                    color: setMobileTextColor()
                                },
                                '& ul, & ol': {
                                    pl: 3,
                                    mb: 2,
                                    '& li': {
                                        mb: 1
                                    }
                                },
                                '& a': {
                                    color: 'primary.main',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    }
                                },
                                '& strong': {
                                    fontWeight: 'bold'
                                }
                            }}
                        />
                    ) : (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '200px'
                        }}>
                            <Typography className="head-font" variant="body1">
                                No privacy policy available.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Container>

            <BottomNavBar qr={tableQr} qrName={tableName} />
        </div>
    );
}

export default PrivacyPolicy;